import type { ReactNode } from 'react';
import type { PermissionKey } from '../types';
import { useHasAppPermission } from '../hooks/useHasAppPermission';

export enum PermissionLevel {
  None = 0,
  View = 1,
  Edit = 2,
  Admin = 3,
}

interface CheckAppPermissionsProps {
  app: PermissionKey;
  requiredLevel?: PermissionLevel;
  children: ReactNode;
}

export default function CheckAppPermissions({ app, requiredLevel = PermissionLevel.View, children }: CheckAppPermissionsProps) {
  const hasAppPermission = useHasAppPermission(app, requiredLevel);

  if (!hasAppPermission) return null;

  return <>{children}</>;
}
